<template>
    <div class="p-6">
        <div v-if="extracurricularActivities.length === 0"
            class="h-full flex flex-col justify-center items-center text-center">
            <div class="text-gray-500">
                <font-awesome-icon :icon="['fas', 'users']" class="text-4xl mb-4" />
                <p class="text-lg">No extracurricular activities found</p>
            </div>
        </div>

        <div v-else class="space-y-4">
            <div v-for="(activity, index) in extracurricularActivities" :key="activity.id"
                class="bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors">
                <div class="flex justify-between items-start mb-2">
                    <h3 class="font-semibold text-gray-800">
                        {{ activity.title }}
                    </h3>
                    <span class="text-xs text-gray-500">
                        {{ formatDate(activity.created_at) }}
                    </span>
                </div>

                <div class="text-gray-700">
                    <p class="text-sm">
                        <span class="font-medium text-gray-600">Activity #{{ index + 1 }}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StudentLifeModal',
    props: {
        extracurricularActivities: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return '—';
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        }
    }
};
</script>
